/**
 * 打字期间冻结视口监听（牌桌嘴炮）。
 *
 * 软键盘弹起时 `visualViewport` 会缩成半屏，而全站有两处在盯着它：
 *  - `viewportUnits.ts` 会把「innerHeight − vv.height」当成浏览器工具栏写进 `--toolbar-guard`
 *    —— 候选条、键盘动画中途的那几帧都落在它认的 2–96px 区间里，dock 忽然变高、整桌重排；
 *  - `useViewportMode.ts` 会在折叠屏上把 691×330 判成手机档 —— 换美术、掐掉进行中的 CSS 动画。
 * 键盘不是视口变化。锁住期间两处都照旧用锁之前的量值，解锁后补量一次。
 */
let locked = false

export function isKeyboardLocked(): boolean {
  return locked
}

export function setKeyboardLocked(on: boolean): void {
  if (locked === on) return
  locked = on
  const root = globalThis.document?.documentElement
  if (root !== undefined && root !== null) {
    if (on) root.dataset['kb'] = 'on'
    else delete root.dataset['kb']
  }
  // 解锁后补量一次：锁定期间真的转过屏、收过工具栏的话，这里把它追上
  if (!on && typeof globalThis.dispatchEvent === 'function' && typeof Event === 'function') {
    globalThis.dispatchEvent(new Event('resize'))
  }
}
